import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import { homeContentApi } from "Services/allApi";

import "react-toastify/dist/ReactToastify.css";
import { EditHomeContentApi } from "Services/allApi";

function HomeContent() {
  const [formData, setFormData] = useState({
    mainheader: "",
    subhead: "",
    main_head_section_1: "",
    main_head_section_2: "",
    main_head_section_3: "",
    main_description: "",
    main_button_content: "",
    main_button_link: "",
    main_phone_number: "",
  });

  const [contentId, setContentId] = useState(null);

  // Fetch the home content data when the component mounts
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await homeContentApi();
        if (!response.error && response.data && response.data.length > 0) {
          const data = response.data[0]; // Assuming it's an array with one object
          setContentId(data.id); // Set the ID for updating
          setFormData({
            mainheader: data.main_header || "",
            subhead: data.sub_head || "",
            main_head_section_1: data.main_head_section_1 || "",
            main_head_section_2: data.main_head_section_2 || "",
            main_head_section_3: data.main_head_section_3 || "",
            main_description: data.main_description || "",
            main_button_content: data.main_button_content || "",
            main_button_link: data.main_button_link || "",
            main_phone_number: data.main_phone_number || "",
          });
        } else {
          toast.error("Error fetching home content data.");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        toast.error("Failed to fetch home content!");
      }
    };
    fetchData();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleUpdate = async () => {
    if (!contentId) {
      toast.error("Content ID is missing!");
      return;
    }
    const phoneNumberRegex = /^\+?[0-9 ]{10,15}$/;
    if (!phoneNumberRegex.test(formData.main_phone_number.trim().replace(/\s+/g, ''))) {
      toast.error("Invalid phone number! Please enter a valid 10-digit phone number.");
      return;
    }

    try {
      const updatedData = {
        main_header: formData.mainheader,
        sub_head: formData.subhead,
        main_head_section_1: formData.main_head_section_1,
        main_head_section_2: formData.main_head_section_2,
        main_head_section_3: formData.main_head_section_3,
        main_description: formData.main_description,
        main_button_content: formData.main_button_content,
        main_button_link: formData.main_button_link,
        main_phone_number: formData.main_phone_number,
      };

      const response = await EditHomeContentApi(contentId, updatedData);
      toast.success("Home content updated successfully!");
      console.log("Update response:", response);
    } catch (error) {
      console.error("Error updating home content:", error);
      toast.error("Failed to update home content!");
    }
  };

  return (
    <>
      <div>
        <div className="max-w-6xl mx-auto p-6 bg-white shadow-lg rounded-lg mt-3  dark:!bg-navy-700 dark:text-white">
        <h2 className="text-center text-3xl font-bold mb-5 mt-2">Home Contents</h2>
        <hr className="mb-4" />
          <div className="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-4 mt-5">
            {/* mainheader */}
            <div className="sm:col-span-2">
              <label htmlFor="mainheader" className="block font-medium text-gray-900">Main Header</label>
              <div className="mt-2">
                <input
                  type="text"
                  name="mainheader"
                  id="mainheader"
                  value={formData.mainheader}
                  onChange={handleInputChange}
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-purple-800 sm:text-sm/6  dark:!bg-navy-700 dark:text-white"
                />
              </div>
            </div>

            {/* sub head */}
            <div className="sm:col-span-2">
              <div>
              <label htmlFor="subhead" className=" block font-medium text-gray-900">Sub head</label>
              </div>
              
              <div className="mt-2">
                <input
                  type="text"
                  name="subhead"
                  id="subhead"
                  value={formData.subhead}
                  onChange={handleInputChange}
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-purple-800 sm:text-sm/6  dark:!bg-navy-700 dark:text-white"
                />
              </div>
            </div>

            {/* Main head sections */}
            <div className="sm:col-span-4">
              <label htmlFor="main_head_section_1" className="block font-medium text-gray-900">Main head section 1</label>
              <div className="mt-2">
                <input
                  type="text"
                  name="main_head_section_1"
                  id="main_head_section_1"
                  value={formData.main_head_section_1}
                  onChange={handleInputChange}
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-purple-800 sm:text-sm/6  dark:!bg-navy-700 dark:text-white"
                />
              </div>
            </div>

            {/* Main head section 2 */}
            <div className="sm:col-span-2">
              <label htmlFor="main_head_section_2" className="block font-medium text-gray-900">Main head section 2</label>
              <div className="mt-2">
                <input
                  type="text"
                  name="main_head_section_2"
                  id="main_head_section_2"
                  value={formData.main_head_section_2}
                  onChange={handleInputChange}
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-purple-800 sm:text-sm/6  dark:!bg-navy-700 dark:text-white"
                />
              </div>
            </div>

            {/* Main head section 3 */}
            <div className="sm:col-span-2">
              <label htmlFor="main_head_section_3" className="block font-medium text-gray-900">Main head section 3</label>
              <div className="mt-2">
                <input
                  type="text"
                  name="main_head_section_3"
                  id="main_head_section_3"
                  value={formData.main_head_section_3}
                  onChange={handleInputChange}
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-purple-800 sm:text-sm/6  dark:!bg-navy-700 dark:text-white"
                />
              </div>
            </div>

            {/* Main description */}
            <div className="sm:col-span-4">
              <label htmlFor="main_description" className="block font-medium text-gray-900">Main Description</label>
              <div className="mt-2">
                <textarea
                  type="text"
                  name="main_description"
                  id="main_description"
                  value={formData.main_description}
                  onChange={handleInputChange}
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-purple-800 sm:text-sm/6  dark:!bg-navy-700 dark:text-white"
                />
              </div>
            </div>

            {/* Main button content */}
            <div className="sm:col-span-2">
              <label htmlFor="main_button_content" className="block font-medium text-gray-900">Main button content</label>
              <div className="mt-2">
                <input
                  type="text"
                  name="main_button_content"
                  id="main_button_content"
                  value={formData.main_button_content}
                  onChange={handleInputChange}
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-purple-800 sm:text-sm/6  dark:!bg-navy-700 dark:text-white"
                />
              </div>
            </div>

            {/* Main button link */}
            <div className="sm:col-span-2">
              <label htmlFor="main_button_link" className="block font-medium text-gray-900">Main button link</label>
              <div className="mt-2">
                <input
                  type="text"
                  name="main_button_link"
                  id="main_button_link"
                  value={formData.main_button_link}
                  onChange={handleInputChange}
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-purple-800 sm:text-sm/6  dark:!bg-navy-700 dark:text-white"
                />
              </div>
            </div>

            {/* Main phone number */}
            <div className="sm:col-span-2">
              <label htmlFor="main_phone_number" className="block font-medium text-gray-900">Main phone number</label>
              <div className="mt-2">
                <input
                  type="number"
                  name="main_phone_number"
                  id="main_phone_number"
                  value={formData.main_phone_number}
                  onChange={handleInputChange}
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-purple-800 sm:text-sm/6  dark:!bg-navy-700 dark:text-white"
                />
              </div>
            </div>

          </div>
          <hr  className='mt-5 mb-5'/>
          <div className="flex justify-center">
            <button
              type="button"
              onClick={handleUpdate}
              className="px-4 py-2 bg-purple-600 text-white rounded-md shadow hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-purple-500"
            >
              Update
            </button>
          </div>
          
        </div>
      </div>
    </>
  );
}

export default HomeContent;
